import React from "react";
import {
  ClockCircleOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import "./style.css";

const formatLabel = (value) =>
  String(value || "")
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

const formatAmount = (value) => `$${(parseFloat(value) || 0).toFixed(2)}`;

const getOpenRequestState = (openRequest, fallbackMessage) => {
  const status = String(
    openRequest?.status || openRequest?.request?.status || "",
  ).toLowerCase();

  const requestId = openRequest?.request?.id;

  return {
    canCreate: openRequest?.can_create_request !== false,
    resubmitId:
      status === "revision_requested" && requestId != null ? requestId : null,
    hasOpen: Boolean(
      openRequest &&
        (openRequest.request || openRequest.status || openRequest.message),
    ),
    status: status || "pending",
    message: openRequest?.message || fallbackMessage,
  };
};

const OpenRequestBanner = ({
  openRequest,
  label,
  fallbackMessage,
  onClick,
}) => {
  const { hasOpen, status, message } = getOpenRequestState(
    openRequest,
    fallbackMessage,
  );
  if (!hasOpen) return null;

  const amount = openRequest?.request?.amount;
  const requestId = openRequest?.request?.request_id;
  const reason =
    status === "revision_requested"
      ? String(openRequest?.request?.audit_notes || "").trim()
      : "";

  return (
    <div
      className={`open-request-banner open-request-banner--${status}${onClick ? " open-request-banner--clickable" : ""}`}
      {...(onClick && {
        role: "button",
        tabIndex: 0,
        onClick,
        onKeyDown: (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onClick();
          }
        },
      })}
    >
      <div className="open-request-banner__icon">
        {status === "revision_requested" ? (
          <ExclamationCircleOutlined />
        ) : (
          <ClockCircleOutlined />
        )}
      </div>

      <div className="open-request-banner__body">
        <div className="open-request-banner__title">
          <span>{label}</span>
          <span className="open-request-banner__badge">
            {formatLabel(status)}
          </span>
        </div>
        <div className="open-request-banner__message">{message}</div>
        {reason && (
          <div className="open-request-banner__reason">
            <span className="open-request-banner__reason-label">Reason</span>
            {reason}
          </div>
        )}
      </div>

      {(amount != null || requestId) && (
        <div className="open-request-banner__meta">
          {amount != null && (
            <span className="open-request-banner__amount">
              {formatAmount(amount)}
            </span>
          )}
          {requestId && (
            <span className="open-request-banner__id">{requestId}</span>
          )}
        </div>
      )}
    </div>
  );
};

export { getOpenRequestState };
export default OpenRequestBanner;
